import * as React from 'react';
import Button from '@mui/material/Button';
import { Paper } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import SwipeableEdgeDrawerSort from './SwipeableEdgeDrawerSort';
import DialogFiltr from './DialogFiltr/DialogFiltr';


const StyledBoxBtn = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  minHeight: "45px",
  backgroundColor: "#fff",
}));

const FullScreenFiltrMoby = (props) => {
  const [open, setOpen] = React.useState(false);
  const [opensort, setOpenSort] = React.useState(false);

  let submitForm = () => {
    props.setCurrentPage(1);
    let filter = "";
    let currentPage=1;
    let valueSelected= props.valueSelected;
    props.paramsQuerry.paramsQuerry.map((getpar, ii) => {
      let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
      let filtrSort = getpar[0];
      let filtrSortValue = getpar[1];
      let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
      let filtrGetParamsValue = Number(getpar[1]);

      if (filtrSort == "tag") {

        filter +=`${filtrSort}=${filtrSortValue}&`;
      }
    });

    for (var key in props.checked) {
      props.checked[key].map(u => {
        filter += `filter[${key}][]=${u}&`;
       
      })
    }
    //?filter[style][]=356

    filter = filter.trim().slice(0, -1);

    props.setFiltr("?" + filter);
    props.getCatalogItems(props.pageSize, currentPage, "&" + filter + "&" + valueSelected);

    props.getFiltersUrl(filter);
    // props.params.navigate(`/${props.catalogUrl}/?` + filter + "&" + valueSelected);

  }
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpenSort = () => {
    setOpenSort(true);
    
  };
  const handleClose = () => {
    setOpen(false);
  };
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  let resetForm = () => {
    props.setCurrentPage(1);
    let valueSelected= props.valueSelected;
    let checkedNull = [];
    let currentPage = 1;
    props.setCheckenFiltr(checkedNull);
    let filter = "";

    filter = filter.trim().slice(0, -1);


    props.setFiltr("?" + filter);
    props.getCatalogItems(props.pageSize, currentPage, filter);
    // props.params.navigate(/${props.catalogUrl}/?${valueSelected}``);
  }
  
  return (
    <>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2 }} elevation={3}>
        <StyledBoxBtn sx={{ textAlign: 'center', pt: 1 }}>
          <Button  sx={{ color: "#ff6000" }} onClick={handleClickOpenSort}>
            Сортировка
          </Button>
          <Button sx={{ color: "#ff6000" }} onClick={handleClickOpen}>
            Фильтр
          </Button>
        </StyledBoxBtn>
      </Paper>
      <SwipeableEdgeDrawerSort  opensort={opensort} toggleDrawer={toggleDrawer} setOpenSort={setOpenSort} {...props} />
      <DialogFiltr open={open} resetForm={resetForm}  handleClose={handleClose} submitForm={submitForm}  {...props}/>
    </>
  );
}




export default FullScreenFiltrMoby;